import React from 'react';
import * as S from './style';
import { FormStatusInfo, Label, Btn } from 'components';
import { ReactComponent as ImgDocReject } from 'assets/img/status/img_doc_reject.svg';

interface Props {
  rjectInfoList: Array<string>;
  documentDenialComment?: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function DocReject({
  rjectInfoList,
  documentDenialComment,
  onClick,
}: Props): React.ReactElement {
  return (
    <FormStatusInfo
      subTitle={['서류 재확인']}
      image={<ImgDocReject />}
      btn={
        <Btn
          height={64}
          fontStyle={'body1_bold'}
          backGroundColor={'blue_900'}
          color={'gray_opacity_50'}
          onClick={onClick}
        >
          {'서류 다시 등록하기'}
        </Btn>
      }
      inHomeBtn={true}
    >
      <S.CaptionWrapper>
        제출해주신 서류를 확인하는 과정에서 재확인이 필요한 점이 있었습니다.
        <br />
        아래 안내 메시지를 참고하여 다시 서류를 등록해주세요.
        <br />
      </S.CaptionWrapper>
      <S.RejectWrapper>
        {rjectInfoList.map((item, index) => (
          <Label
            key={index}
            contents={`- ${item}`}
            fontStyle={'caption'}
            color={'red_900'}
          />
        ))}
      </S.RejectWrapper>
      <S.GuideWrapper>{documentDenialComment}</S.GuideWrapper>
    </FormStatusInfo>
  );
}

export default DocReject;
